module.exports = __webpack_public_path__ + "static/media/yoma_group.f5712cd7.png";